<p-dropdown
  [showClear]="enableEmpty"
  *ngIf="typeLayers as layers"
  (ngModelChange)="onChange($event)"
  [options]="hasForecastLayers(layers) ? groupedLayers(layers) : layers"
  [group]="hasForecastLayers(layers)"
  optionGroupLabel="label"
  optionGroupChildren="items"
  [(ngModel)]="selection"
  [disabled]="disabled"
  [ngModelOptions]="{ standalone: isStandalone }"
  placeholder="auswählen..."
  optionLabel="year"
  dataKey="_id">
  <ng-template pTemplate="selectedItem">
    <div class="flex align-items-center gap-2" *ngIf="selection">
      <i
        [class]="
          selection.published ? 'fas fa-earth-europe' : 'fas fa-house-user'
        "></i>
      <i
        *ngIf="selection.isForecast"
        class="fas fa-gauge"
        pTooltip="Prognosejahr"
        aria-label="Prognosejahr"></i>
      <div>{{ selection.year }}</div>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    @if (selectedTypeId && displayNewYearOption) {
      <div class="p-2 border-bottom-1 surface-border">
        <p-button
          [text]="true"
          [rounded]="true"
          (onClick)="openLayerForm()"
          icon="fas fa-plus"
          label="hinzufügen"></p-button>
      </div>
    }
  </ng-template>
  <ng-template let-group pTemplate="group">
    <div class="flex align-items-center gap-2 text-sm font-semibold">
      <i [class]="group.icon"></i>
      <span>{{ group.label }}</span>
    </div>
  </ng-template>
  <ng-template let-layer pTemplate="item">
    <div class="flex align-items-center gap-2">
      <i
        [class]="
          layer.published ? 'fas fa-earth-europe' : 'fas fa-house-user'
        "></i>
      <span>{{ layer.year }}</span>
    </div>
  </ng-template>
</p-dropdown>
